import { render } from "./EmailSide.vue?vue&type=template&id=36b6a664"
import script from "./EmailSide.vue?vue&type=script&lang=js"
export * from "./EmailSide.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Alison\\Documents\\Dev\\Apps\\av2-portfolio-v3\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__